var map = {
	"./accident-man.png": [
		8307,
		[
			8307
		]
	],
	"./accident.png": [
		5928,
		[
			5928
		]
	],
	"./back.svg": [
		4002,
		[
			4002
		]
	],
	"./banner.svg": [
		1817,
		[
			1817
		]
	],
	"./bg-header.svg": [
		7080,
		[
			7080
		]
	],
	"./bg-login.jpg": [
		1834,
		[
			1834
		]
	],
	"./building.png": [
		4171,
		[
			4171
		]
	],
	"./bycicle.png": [
		8731,
		[
			1112
		]
	],
	"./calendar.svg": [
		3249,
		[
			3249
		]
	],
	"./car-accident.png": [
		1035,
		[
			1035
		]
	],
	"./car-logo.svg": [
		4405,
		[
			4405
		]
	],
	"./car.png": [
		1721,
		[
			1721
		]
	],
	"./care.png": [
		7792,
		[
			7792
		]
	],
	"./caret-left-sm.svg": [
		1935,
		[
			1935
		]
	],
	"./caret-right-sm.svg": [
		1538,
		[
			1538
		]
	],
	"./check.svg": [
		6729,
		[
			6729
		]
	],
	"./close-circle-outline.svg": [
		5995,
		[
			5995
		]
	],
	"./close-sm.svg": [
		842,
		[
			842
		]
	],
	"./doctor.png": [
		4610,
		[
			4610
		]
	],
	"./down-arrow.svg": [
		5927,
		[
			5927
		]
	],
	"./earthquake.png": [
		3999,
		[
			6380
		]
	],
	"./elevator.png": [
		565,
		[
			565
		]
	],
	"./family.png": [
		9955,
		[
			9955
		]
	],
	"./filter.svg": [
		4969,
		[
			4969
		]
	],
	"./globe.png": [
		9244,
		[
			9244
		]
	],
	"./hero-1.png": [
		9037,
		[
			9037
		]
	],
	"./hero-1.svg": [
		2193,
		[
			2193
		]
	],
	"./hero-2.svg": [
		9058,
		[
			9058
		]
	],
	"./home.svg": [
		4278,
		[
			4278
		]
	],
	"./house.svg": [
		7885,
		[
			7885
		]
	],
	"./insurance-logo.svg": [
		9287,
		[
			9287
		]
	],
	"./left-arrow-small.svg": [
		6882,
		[
			6882
		]
	],
	"./loading-circle-light-gray.svg": [
		7287,
		[
			7287
		]
	],
	"./logo-icon.svg": [
		5396,
		[
			5396
		]
	],
	"./logo-text.svg": [
		454,
		[
			454
		]
	],
	"./logo.png": [
		2806,
		[
			2806
		]
	],
	"./logo.svg": [
		3914,
		[
			3914
		]
	],
	"./old.png": [
		3836,
		[
			3836
		]
	],
	"./patient.png": [
		6584,
		[
			6584
		]
	],
	"./plate-flag.svg": [
		9232,
		[
			9232
		]
	],
	"./plate-ir.svg": [
		495,
		[
			495
		]
	],
	"./plate-iran.svg": [
		1602,
		[
			1602
		]
	],
	"./setting.svg": [
		4621,
		[
			4621
		]
	],
	"./shopping-bag.svg": [
		3854,
		[
			3854
		]
	],
	"./stethoscope.png": [
		79,
		[
			2460
		]
	],
	"./transportation.png": [
		7273,
		[
			7273
		]
	],
	"./wepod-cart-active.svg": [
		198,
		[
			198
		]
	],
	"./wepod-cart.svg": [
		7284,
		[
			4903
		]
	],
	"./wepod-elevator.svg": [
		6019,
		[
			6019
		]
	],
	"./wepod-fire.svg": [
		117,
		[
			117
		]
	],
	"./wepod-home-active.svg": [
		5419,
		[
			5419
		]
	],
	"./wepod-home.svg": [
		9080,
		[
			9080
		]
	],
	"./wepod-individual-accident-packages.svg": [
		9556,
		[
			9556
		]
	],
	"./wepod-individual-accident.svg": [
		1922,
		[
			1922
		]
	],
	"./wepod-life-premium.svg": [
		551,
		[
			551
		]
	],
	"./wepod-life.svg": [
		4787,
		[
			4787
		]
	],
	"./wepod-services-active.svg": [
		3816,
		[
			3816
		]
	],
	"./wepod-services.svg": [
		597,
		[
			597
		]
	],
	"./wepod-third-party.svg": [
		6511,
		[
			6511
		]
	],
	"./wepod-travel.svg": [
		6141,
		[
			6141
		]
	],
	"./wepod-treatment.svg": [
		7023,
		[
			7023
		]
	],
	"./wepod-vehicle-body.svg": [
		1560,
		[
			1560
		]
	],
	"./yellow-umbrella.jpg": [
		3794,
		[
			3794
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1628;
module.exports = webpackAsyncContext;